var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from '@patternfly/react-styles';
import { Title } from '../Title';
import { css } from '@patternfly/react-styles';
import styles from '../../@patternfly/patternfly-next/components/LoginBox/login-box.css.js';
import { global_spacer_md, global_spacer_sm } from '@patternfly/react-tokens';
import displayStyles from '../../@patternfly/patternfly-next/utilities/Display/display.css.js';
import flexAlignment from '../../@patternfly/patternfly-next/utilities/Flex/flex.css.js';

var propTypes = {
  /** Content rendered inside the LoginBox Header */
  children: PropTypes.node,
  /** Additional classes added to the LoginBox Header */
  className: PropTypes.string,
  /** Dropdown component for the LoginBox Header */
  dropdown: PropTypes.node,
  /** Title for the LoginBox Header */
  title: PropTypes.string,
  /** Subtitle that contains the Text, URL, and URL Text for the LoginBox Header */
  subtitle: PropTypes.node
};

var defaultProps = {
  children: null,
  className: '',
  dropdown: null,
  title: '',
  subtitle: ''
};

var tokenStyles = StyleSheet.create({
  title: {
    marginBottom: global_spacer_sm.var
  },
  text: {
    marginLeft: global_spacer_md.var
  }
});

var LoginBoxHeader = function LoginBoxHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dropdown = _ref.dropdown,
      title = _ref.title,
      subtitle = _ref.subtitle,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'dropdown', 'title', 'subtitle']);

  return React.createElement(
    'div',
    _extends({ className: css(styles.loginBoxHeader, className) }, props),
    React.createElement(
      Title,
      { className: css(tokenStyles.title), size: '3xl' },
      title
    ),
    React.createElement(
      'div',
      { className: css(displayStyles.displayInlineFlex, flexAlignment.alignItemsCenter) },
      dropdown,
      subtitle && React.createElement(
        'p',
        { className: css(tokenStyles.text) },
        subtitle
      )
    ),
    children
  );
};

LoginBoxHeader.propTypes = propTypes;
LoginBoxHeader.defaultProps = defaultProps;

export default LoginBoxHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/LoginPage/LoginBoxHeader.js
// module id = 255
// module chunks = 0